import Vue from "vue";
export default {
  currentLang: function() {
    return Vue.i18n.locale();
  },
  getWholesaleStatus: function(state) {
    return state.pageProfile.wholesale_status === true && state.wholesale.length > 0;
  },
  getWholesale: function(state) {
    return state.wholesale;
  },
  isEmptyCart: function(state) {
    return state.cart.length == 0;
  },
  getCart: function(state) {
    var resultCart = [];
    var cart = state.cart.sort(function(a, b) {
      if (a > b) {
        return -1;
      } else if (a < b) {
        return 1;
      } else {
        return 0;
      }
    });

    var total_quantity = 0;
    cart.map(function(product) {
      total_quantity += product.quantity;
    });

    cart.map(function(product) {
      var p = product;
      var bundleproduct_quantity = 0;
      var bundleproduct = cart.filter((c) => {
        return c.id == p.id;
      });

      bundleproduct.map((b) => {
        bundleproduct_quantity += b.quantity;
      });

      var isFoundBundle = false;
      if (product.productbundle)
        isFoundBundle = product.productbundle.find(function(bundle) {
          if (
            bundle.maxquantity >= bundleproduct_quantity &&
            bundleproduct_quantity >= bundle.minquantity
          ) {
            return true;
          }
        });
      var prodprice_total = 0;
      // console.log(product);
      if (state.isWholesale && state.wholesale.length > 0) {
        p.bundle = product.quantity;
        var isFoundWholesale = false;

        state.wholesale.map(function(bundle) {
          if (bundle.maxquantity >= total_quantity && total_quantity >= bundle.minquantity) {
            prodprice_total = parseFloat(bundle.price);
            isFoundWholesale = true;
            return;
          }
        });

        if (isFoundWholesale) {
          // console.log("wholesale");
          p.bundleprice = prodprice_total * product.quantity;
          resultCart.push(p);
          return false;
        }
      }
      if (isFoundBundle) {
        var isFoundProductBundle = false;
        product.productbundle.map(function(bundle) {
          if (
            bundle.maxquantity >= bundleproduct_quantity &&
            bundleproduct_quantity >= bundle.minquantity
          ) {
            prodprice_total = parseFloat(bundle.price);
            isFoundProductBundle = true;
            return;
          }
        });
        if (isFoundProductBundle) {
          // console.log("bundle");
          p.bundleprice = prodprice_total * product.quantity;
          resultCart.push(p);
          return false;
        }
      }
      if (product.price != product.discountprice) {
        // console.log("discount", product.price, product.discountprice);
        p.bundleprice = parseFloat(product.discountprice) * product.quantity;
        resultCart.push(p);
        return false;
      }
      {
        // console.log("default", product.price, product.discountprice);
        p.bundleprice = parseFloat(product.price) * product.quantity;
        resultCart.push(p);
        return false;
      }

      // resultCart.push(p);
    });
    return resultCart;
  },
  getPageProfile: function(state) {
    var profile = { ...state.pageProfile };
    profile.type = "default";
    if (state.pageProfile && state.pageProfile.ispremium == true) {
      if (state.bearhouse.includes(state.pageProfile.pageid)) {
        profile.type = "bearhouse";
      } else if (state.khaiwhan.includes(state.pageProfile.pageid)) {
        profile.type = "khaiwhan";
      } else if (state.ros.includes(state.pageProfile.pageid)) {
        profile.type = "ros";
      } else if (
        [
          "103045347810541",
          "2154616301525189",
          "100160834719075",
          "356805901794673",
          "1924579627803469",
          "104679561577508",
          "493004761144617",
          "934400496731284",
          "330946854291292",
          "301557697175910",
        ].includes(state.pageProfile.pageid)
      ) {
        profile.type = "gaigao";
      } else if (["114660513608160"].includes(state.pageProfile.pageid)) {
        profile.type = "forex";
      } else if (["105256301109350", "100750874824298"].includes(state.pageProfile.pageid)) {
        profile.type = "purelife";
      } else if (
        [
          "148831989096546",
          "1229692217050821",
          "135565533158593",
          "488563718210335",
          "799590883441878",
        ].includes(state.pageProfile.pageid)
      ) {
        profile.type = "monobo";
      } else if (["113937150302402"].includes(state.pageProfile.pageid)) {
        profile.type = "ros";
      } else if (
        ["155062857877705", "107057644128258", "119155854798330"].includes(state.pageProfile.pageid)
      ) {
        profile.type = "smoothe";
      } else if (["104974550989962", "100855974907941"].includes(state.pageProfile.pageid)) {
        profile.type = "gaigacha";
      } else if (["1775425925847885"].includes(state.pageProfile.pageid)) {
        profile.type = "kanom";
      } else if (["104944601303072"].includes(state.pageProfile.pageid)) {
        profile.type = "waratapob";
      } else if (
        ["bec"].includes(state.pageProfile.theme) ||
        ["505923009941524", "456187931239759"].includes(state.pageProfile.pageid)
      ) {
        profile.type = "bec";
      } else if (["108973710878860", "326180737483767"].includes(state.pageProfile.pageid)) {
        profile.type = "rabbit";
      } else if (["102459484852582"].includes(state.pageProfile.pageid)) {
        profile.type = "nvbb";
      } else if (["102434044554028"].includes(state.pageProfile.pageid)) {
        profile.type = "fastdeli";
      } else if (["111149990806742", "107410831174668"].includes(state.pageProfile.pageid)) {
        profile.type = "constructpage";
      } else if (
        ["176922345693076", "809510349133469", "103876431747147"].includes(state.pageProfile.pageid)
      ) {
        profile.type = "chillpainai";
      } else if (["runkan"].includes(state.pageProfile.theme)) {
        profile.type = "runkan";
      } else if (["104716585038207", "362065616073"].includes(state.pageProfile.pageid)) {
        profile.type = "cutepress";
      }
    }
    return profile;
  },
  getLoadingPageProfile: function(state) {
    return state.loadingPageProfile;
  },
  getTheme: function(state) {
    return state.theme;
  },
  getIosPadding() {
    var isPadding = false;
    if (
      navigator.userAgent.indexOf("FB") != -1 ||
      (navigator.userAgent.indexOf("Line") != -1 && navigator.userAgent.indexOf("iphone") != -1)
    ) {
      isPadding = true;
    }
    return isPadding;
  },
};
